<template>
  <div class="institution-panel">
    <div class="institution-panel__header">
      <img :src="require('assets/images/new-qp-logo.svg')" alt="Quero Pago" class="institution-panel__qp-logo">
      <template v-if="institution.name">
        <z-title class="header__divider" size="medium">
          |
        </z-title>
        <z-title size="extra-large">
          {{ institution.name }}
        </z-title>
      </template>
    </div>
    <router-view :encrypted-institution-id="encryptedInstitutionId" />
  </div>
</template>

<script>
import InstitutionPanelService from 'services/InstitutionPanelService';

export default {
  data() {
    return {
      institution: {},
      encryptedInstitutionId: null,
    };
  },
  beforeMount() {
    this.encryptedInstitutionId = this.$route.params.encryptedInstitutionId;

    InstitutionPanelService.loadInstitution(this.encryptedInstitutionId)
      .then((data) => {
        this.institution = data;
      })
      .catch(() => {
        this.$toast.show('danger', 'Erro ao carregar instituição, tente novamente mais tarde', 4000);
        this.$router.push({ name: 'landing' });
      });
  },
};
</script>

<style lang="scss" scoped>
.institution-panel {
  margin: 0 auto;
  max-width: 1140px;
  padding: var(--space-medium);
}

.institution-panel__header {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: var(--space-jumbo);
  margin-top: var(--space-giant);
  width: 100%;

  @media screen and (max-width: $screen-md-max) {
    flex-direction: column;
  }
}

.header__divider {
  margin: 0 var(--space-medium);

  @media screen and (max-width: $screen-md-max) {
    display: none;
  }
}

.institution-panel__qp-logo {
  height: var(--size-jumbo);
  width: auto;

  @media screen and (max-width: $screen-md-max) {
    height: var(--size-extra-large);
    margin-bottom: var(--space-medium);
  }
}
</style>
